// extracted by mini-css-extract-plugin
module.exports = {"header":"page_header__TIPYM","header-content":"page_header-content__sbfop","header-title":"page_header-title__yfanw","header-description":"page_header-description__Mlim8"};